<template>
	<div>

		<!-- <div class="display_msg" v-if="!listItemObject.items.length">No Items</div> -->

		<div v-scroll="onScroll">
			
			<div full-width class="search-filter three-btn">
		    	<v-text-field hide-details elevation-10 clearable flat solo placeholder="Search..." v-model.lazy="searchValue" @input="fn_searchItem" class="search-box" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
		    	
		    	<div v-ripple style="float:left" class="filter-btn" @click="fn_openFilterDialog">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -6px;right: 6px;color: #4b77be;" v-if="selectedTransactionListIds.length">&bull;</span>
		    	</div>

		    	<div v-ripple class="filter-btn" @click="fn_newInvoice">
		    		<!-- <v-icon class="primary-color">add_circle_outline</v-icon> -->
		    		<img src="../../../assets/icon_invoice.svg" style="opacity:0.54" alt="icon_invoice">
		    	</div>

		    	<div v-ripple style="float:left" class="filter-btn" @click="add">
		    		<v-icon>add</v-icon>
		    	</div>
		    </div>

		    <!-- <div style="clear:both" class="padding-all-16 light-opacity-color center-align" v-if="!listItemObject.totalCount">There are no transactions!</div> -->
			
			<div style="clear:both">
				
				<v-list grey-back three-line nopadding v-if="listItemObject.items && listItemObject.items.length">

					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.transactionId">
						<v-list-tile class="right-subtitle-tile auto-height-tile" @click="fn_itemClick(item, index)">
						    <v-list-tile-content>
						      <v-list-tile-title>{{item.accountLedgerName ? item.accountLedgerName : fn_transactionName(item)}}</v-list-tile-title>
						      <v-list-tile-sub-title v-if="item.accountLedgerName">{{fn_transactionName(item)}}</v-list-tile-sub-title>
						      <v-list-tile-sub-title>
						      	<span v-if="item.mergeTransactionNumber" class="primary-color">{{item.mergeTransactionNumber}}</span>
						      	{{item.mergeTransactionNumber ? ' | ' : ''}}
						      	{{item.transactionDate | moment("DD-MMM-YYYY")}}
						      </v-list-tile-sub-title>
							  <v-list-tile-sub-title class="mb-1" v-if="$root.TransactionSettings.showPartyMobile && item.primaryMobileNumber">Ph: {{ item.primaryMobileNumber }}</v-list-tile-sub-title>
						      <!-- <v-list-tile-sub-title>{{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title> -->
						    </v-list-tile-content>

						    <v-list-tile-action align-flex-end>
						    	<div class="warning-label" v-if="!item.status">Cancelled</div>
						    	<!-- empty div to align amount at bottom of the tile -->
						    	<div v-else></div>
						    	<div v-if="item.transactionListId!=40005">&#8377; {{$root.numberToLocale(item.roundedAmount)}}</div>
						    </v-list-tile-action>

						</v-list-tile>

						<v-divider v-if="item.invoiceTemplate || item.transactionListId == 40005 || item.transactionListId == 40006"></v-divider>
						<div right-align style="padding:2px 6px" v-if="item.invoiceTemplate || item.transactionListId == 40005 || item.transactionListId == 40006">
							<v-btn nomargin icon flat @click="bindInvoiceTemplate('thermal', item)" v-if="$root.ThermalPrintSettings && $root.ThermalPrintSettings.enableThermalPrint && (getFormNameByListId(item.transactionListId) == 'Sale' || getFormNameByListId(item.transactionListId) == 'Receipt' || getFormNameByListId(item.transactionListId) == 'Payment')"><v-icon font20>receipt</v-icon></v-btn>
							<v-btn nomargin icon flat @click="bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
							<v-btn nomargin icon flat @click="bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="preview(item, fn_transactionName)">
					    		<img src="../../../assets/icon_preview_black.svg" style="width:20px" alt="whatapp_icon"></img>
					    	</v-btn>
					    </div>

						<!-- <v-divider v-if="listItemObject.items.length-1 != index"></v-divider> -->
					</div>

					<!-- <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
						<div slot="no-more"></div>
						<div slot="no-results"></div>
					</infinite-loading> -->


				</v-list>

				<transition name="fade" mode="out-in">

					<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
						<v-card-text @click="add">

							<div center-align>
				            	<div v-ripple class="placeholder-icon">
				            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
				            		<img src="../../../assets/icon_wallet.svg" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color">Create New Transaction</p>
				            </div>
						</v-card-text>
					</v-card>

					<!-- <v-card v-if="showPlaceHolder && !listItemObject.totalCount" noshadow style="height: calc(100vh - 104px);display: flex;align-items: center;">
						<v-card-text>

							<div center-align>
				            	<div @click="add" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
				            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
				            		<img src="../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color" style="line-height:28px !important">Create New Transaction</p>
				            </div>

						</v-card-text>
					</v-card> -->
				</transition>

			</div>

			<!-- <div style="clear:both" class="padding-all-16 light-opacity-color center-align" v-if="!listItemObject.totalCount">There are no transactions!</div> -->

			<!-- <div padding-all-16 center-align>
				<v-progress-circular indeterminate color="primary" v-if="loadMore"></v-progress-circular>
			</div> -->
		</div>

		<dialog-transaction-list ref="ref_dialogTransactionList" :transactionForms="transactionForms" :selectedTransactionListIds="selectedTransactionListIds" :selectItems="fn_selectItems" :clearAll="fn_clearAll"></dialog-transaction-list>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../config.js').configs.bottomSheetMenu;
const transactionForms = require('../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../config.js').configs.transactionTypes;

import dialogTransactions from '../dialogs/dialog_transaction_list'
// import InfiniteLoading from 'vue-infinite-loading';

	export default{
		props:['preview', 'bindInvoiceTemplate', 'add', 'getFormNameByListId'],
		components: {
		    // InfiniteLoading,
		    'dialog-transaction-list':dialogTransactions
		},
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0, "saleTotal":0, "receiptTotal":0},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				// transactionListId:null,
				transactionForms:null,
				selectedTransactionListIds:[],
				dialog_transaction_list:false,
				loadMore:false,
				showPlaceHolder:false
			}
		},
		methods:{

			fn_newInvoice: function(){
				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:'/transactions/sales/saleinvoice/items/new', query:{tagId:this.guidWeb()}});
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_transactionName: function(item){
				for(let i=0; i<transactionForms.length; i++){
					if(transactionForms[i].id == item.transactionListId){
						return transactionForms[i].title;
					}
				}
			},

			fn_openFilterDialog: function(){
				this.transactionForms = JSON.parse(JSON.stringify(transactionForms));

				for(let i=0; i<this.transactionForms.length; i++){
					if(this.transactionForms[i].id == 30001){
						this.transactionForms[i].title == "Payment In";
					}
					if(this.transactionForms[i].id == 30002){
						this.transactionForms[i].title == "Payment Out";
					}
					if(this.transactionForms[i].id == 30004){
						this.transactionForms[i].title == "Cash and Bank";
					}
				}
				
				this.dialog_transaction_list = true;
			},

			fn_selectItems: function(listId){
				let isRemoved = false;

				let itemIndex = this.selectedTransactionListIds.findIndex(transactionListId=>{
					return transactionListId == listId;
				});

				if(itemIndex != -1){
					this.selectedTransactionListIds.splice(itemIndex, 1);
				}
				else{
					this.selectedTransactionListIds.push(listId)	
				}

				let obj = {};
				obj.selectedTransactionListIds = this.selectedTransactionListIds;
				localStorage.setItem('activity_transaction_filter', JSON.stringify(obj));

				this.fn_searchItem();
			},

			fn_clearAll: function(){
				this.selectedTransactionListIds = [];
				this.dialog_transaction_list = false;
				localStorage.removeItem('activity_transaction_filter');
				this.fn_searchItem();
			},

			// fn_filterTransaction: function(transactionListId){
			// 	if(transactionListId == 'sale'){
			// 		this.transactionListId = transactionTypes.salesInvoice.id;	
			// 	}
			// 	else if(transactionListId == 'receipt'){
			// 		this.transactionListId = transactionTypes.receipt.id;	
			// 	}
			// 	else{
			// 		this.transactionListId = transactionListId;
			// 	}
			// 	this.fn_searchItem();
			// },

			// fn_updateSearch: function(value){
			// 	this.searchValue = value;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.$router.push('/transactions/sales/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+this.selectedItemId+'/edit');
				}
				else if(menuAction=='copy'){
					this.$router.push({path:"/transactions/sales/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
				// else if(menuAction == 'filter'){
				// 	// here "menuId" == "transactionListId"
				// 	this.fn_filterTransaction(menuId);
				// }
			},

			fn_itemClick: function (item, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("transaction_items_state", JSON.stringify(obj));

				this.$root.fn_navigateToDisplayView(item.transactionListId, item.transactionId);
				// this.$router.push('/transactions/sales/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+itemId);
			},

			// fn_getBottomMenu: function (elementId, itemId) {
			// 	itemId ? this.selectedItemId = itemId : '';

			// 	let bottomMenu;

			// 	if(elementId == bottomSheetMenu.toolBar.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.help]};
			// 	}
			// 	else if(elementId == bottomSheetMenu.masterListItems.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.edit]};
			// 	}
				
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			// infiniteHandler($state) {
		 //    	let filterObject = {};
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	!this.searchValue ? this.searchValue = '' : '';
			// 	filterObject.search = this.searchValue.toLowerCase();
			// 	this.selectedTransactionListIds && this.selectedTransactionListIds.length ? filterObject.transactionListId = this.selectedTransactionListIds : '';

			// 	let self = this;
			// 	this.getItems("AllTransactionList", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;
			// 				self.listItemObject.saleTotal = responseJson.saleTotal ? responseJson.saleTotal : 0;
			// 				self.listItemObject.receiptTotal = responseJson.receiptTotal ? responseJson.receiptTotal : 0;

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}
			// 				// self.listItemObject.items = self.listItemObject.items.concat(responseJson.items);
			// 				self.startIndex = self.listItemObject.items.length;

			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					$state.loaded();
			// 				}
			// 				else{
			// 					$state.complete();
			// 				}

			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		 //    },

			// fn_searchItem: function () {
			// 	this.startIndex = 0;
			// 	this.infiniteId += 1;
			// 	this.listItemObject.items = [];
			// }

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				!this.searchValue ? this.searchValue = '' : '';
				filterObject.search = this.searchValue.toLowerCase();

				if(localStorage.getItem('activity_transaction_filter')){
					let data = JSON.parse(localStorage.getItem('activity_transaction_filter'));
					this.selectedTransactionListIds = data.selectedTransactionListIds;
				}

				this.selectedTransactionListIds && this.selectedTransactionListIds.length ? filterObject.transactionListId = this.selectedTransactionListIds : '';
				// Excluding opening stock, opening ledger and stock adjustment
				filterObject.excludeTransactionListIds = [40001, 40003, 40004, 60001];

				let pageState = null;
				if(localStorage.getItem("transaction_items_state")){
					pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				let self = this;
				this.getItems("AllTransactionList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;
							self.listItemObject.saleTotal = responseJson.saleTotal ? responseJson.saleTotal : 0;
							self.listItemObject.receiptTotal = responseJson.receiptTotal ? responseJson.receiptTotal : 0;

							for(let i in responseJson.items){

								if(responseJson.items[i].transactionPhoneNumber){
									responseJson.items[i].primaryMobileNumber = responseJson.items[i].transactionPhoneNumber; 
								}

								if(responseJson.items[i].listItemData && responseJson.items[i].listItemData.length){
									let runningCustomer = responseJson.items[i].listItemData.filter(listItem=>{return listItem.listId == 'running_cash_transaction'});
									if(runningCustomer && runningCustomer.length){
										responseJson.items[i].accountLedgerName = runningCustomer[0].listItemData.partyName;
									}
								}
								// saving transaction date for opening ledger and opening stock one day before opening date
								// therefore incrementing one day here just to show user
								// if(responseJson.items[i].transactionListId == 40001 || responseJson.items[i].transactionListId == 40003){
								// 	let od = new Date(responseJson.items[i].transactionDate);
						  //           od.setDate(od.getDate()+1);
						  //           responseJson.items[i].transactionDate = new Date(od);
								// }
								let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
								// self.listItemObject.items.push(responseJson.items[i]);	
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
									self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
		    	// this.showPlaceHolder = false;
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems();
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/activity/contents/transaction.vue